import React from "react";

import { faPencilAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "formik";
import styled from "styled-components/macro";

import { ClickableLink as Link } from "components/Link";

import { getHashLocation } from "lib/navigation";

export const StyledForm = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints[0]}px) {
    margin: ${({ theme }) => theme.space[3]}px;
  }
`;

export const ButtonLink = styled(Link)`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border: none;
  border-radius: ${({ theme }) => theme.radii[1]}px;
  cursor: pointer;
  height: ${({ theme }) => theme.space[4]}px;
  margin-left: ${({ theme }) => theme.space[1]}px;
  align-self: flex-end;
`;

export const EditButton = ({ to }) => (
  <ButtonLink to={getHashLocation(to)}>
    <Pencil icon={faPencilAlt} />
  </ButtonLink>
);

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
`;

export const FullWidthGridRow = styled(GridRow)`
  grid-template-columns: 1fr;
`;

export const Pencil = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: white;
`;

export const QuestionnaireRow = styled.div`
  ${({ theme: { space } }) => `padding: ${space[1]}px ${space[1]}px;`}
  align-items: baseline;
`;

export const FormButtonRow = styled.div`
  ${({ theme: { space } }) =>
    `padding: ${space[1]}px ${space[1]}px ${space[1]}px 0;`}
  margin-top: auto;
`;
